




























































































































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import moment from 'moment';
import {発注状況一覧取得依頼バリデータ一覧, 発注状況一覧取得依頼型, 発注状況型, 発注状況更新, 発注状況更新依頼型} from '@/type/purchaseorder/status';
import {発注ステータス区分} from '@/type/purchaseorder/types';
import {loginModule} from '@/store/authentication/login';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import { viewEditingStateModule } from '@/store/state/viewEditingState';
import SenderSelector from '@/components/user/SenderSelector.vue';
import {ValidationResult} from '@/type/validation/result';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    SenderSelector,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
  },
  filters: {
    dateFormat(value: Date): string {
      if (!value) {
        return '';
      }
      moment.locale('ja');
      return moment(value).format('YYYY/MM/DD');
    },
  },
})

export default class ListPurchaseOrderStatuses extends Vue {
  発注状況更新一覧: 発注状況更新[] = [];
  取得依頼: 発注状況一覧取得依頼型 | null = null;
  発注状況更新依頼: 発注状況更新依頼型 = {リスト: []};
  ステータス区分一覧: 発注ステータス区分[] = [];
  バリデーション結果: ValidationResult = new ValidationResult(発注状況一覧取得依頼バリデータ一覧);
  アラートメッセージ: string | string[] | null = null;

  created() {
    this.initialize();
    this.clear();
  }

  async initialize(): Promise<void> {
    this.ステータス区分一覧 = [
      発注ステータス区分.発注完了,
      発注ステータス区分.部分入荷済,
      発注ステータス区分.入荷完了,
      発注ステータス区分.エラー,
      発注ステータス区分.キャンセル,
    ];
    viewEditingStateModule.初期化する();
  }

  async search(): Promise<void> {
    if (this.取得依頼 == null) {
      return;
    }
    this.発注状況更新一覧 = [];
    await api.発注状況一覧を取得する(this.取得依頼)
      .then((response: any) => {
        this.発注状況更新一覧 = response.発注状況一覧.map((発注状況: 発注状況型) => {
          return new 発注状況更新(発注状況, 発注状況.ステータス区分);
        });
        if (this.発注状況更新一覧.length === 0) {
          this.アラートメッセージ = '該当の発注は存在しません';
          this.openDialog('アラート');
          return;
        }
        if (response.アラートメッセージ) {
          this.アラートメッセージ = response.アラートメッセージ;
          this.openDialog('アラート');
        }
      })
      .catch((error: any) => {
        if (error.data.errors) {
          this.アラートメッセージ = error.data.errors;
        }
        if (error.data.message && !error.data.errors) {
          this.アラートメッセージ = [error.data.message];
        }
        this.openDialog('アラート');
      });
  }

  async searchHandler(): Promise<void> {
    if (this.バリデーション結果.hasErrors) {
      this.アラートメッセージ = this.バリデーション結果.getMessages();
      this.openDialog('アラート');
      return;
    }
    await progress(this.search);
  }

  beforeUpdate(): void {
    this.バリデーション結果.validate(this.取得依頼);
    if (this.isChanged) {
      viewEditingStateModule.画面の編集を開始する();
    } else {
      viewEditingStateModule.画面の編集を終了する();
    }
  }

  hasError(name: string): boolean {
    return this.バリデーション結果.hasError(name);
  }

  get isChanged(): boolean {
    return this.発注状況更新一覧.some((発注更新) => 発注更新.isChanged);
  }

  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  getStatusList(ステータス区分: string, 入庫残数: number) {
    if (ステータス区分 === 発注ステータス区分.発注完了 || ステータス区分 === 発注ステータス区分.キャンセル) {
      return [
        発注ステータス区分.発注完了,
        発注ステータス区分.キャンセル,
      ];
    }
    if (入庫残数 === 0) {
      return [ステータス区分];
    }
    if (ステータス区分 === 発注ステータス区分.部分入荷済 || ステータス区分 === 発注ステータス区分.入荷完了) {
      return [
        発注ステータス区分.部分入荷済,
        発注ステータス区分.入荷完了,
      ];
    }
    return [ステータス区分];
  }

  async updateHandler() {
    const requests = this.発注状況更新一覧.filter((発注更新) => 発注更新.isChanged)
      .map((更新対象) => 更新対象.getRequest());
    if (requests.length === 0) {
      this.closeDialog('確定ダイアログ');
      return;
    }
    this.発注状況更新依頼.リスト = requests;
    await progress(this.update);
  }

  async update(): Promise<void> {
    await api.発注状況を更新する(this.発注状況更新依頼)
      .then(
        () => {
          viewEditingStateModule.画面の編集を終了する();
          this.closeDialog('確定ダイアログ');
          this.search();
          this.発注状況更新依頼.リスト = [];
        },
        (error: any) => {
          this.closeDialog('確定ダイアログ');
          if (error.data.errors) {
            this.アラートメッセージ = error.data.errors;
          }
          if (error.data.message && !error.data.errors) {
            this.アラートメッセージ = [error.data.message];
          }
          this.openDialog('アラート');
        },
      );
  }

  clear() {
    this.取得依頼 = {
      メーカー名: '',
      商品名カナ: '',
      発注伝票番号: null,
      発注日From: moment().startOf('month').toDate(),
      発注日To: null,
      確定送信者コード: null,
      卸コード: null,
      ステータス区分: null,
      入庫済み除外区分: '除外しない',
    };
    this.closeDialog('クリアダイアログ');
    viewEditingStateModule.画面の編集を終了する();
    if (!loginModule.管理者である) {
      this.取得依頼.確定送信者コード = loginModule.利用者コードを取得する;
    }
    this.発注状況更新一覧 = [];
    this.発注状況更新依頼 = {リスト: []};
  }
}
